import HundredBricksAPIError from '../../HundredBricksAPIError';
class EnableAutomaticInvoicingError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('EnableAutomaticInvoicingError', ...args);
    }
}
export default EnableAutomaticInvoicingError;
